enum FormType {
    PDF = 1,
    APSS = 3
}

export { FormType };
